import React, {useEffect, useState} from 'react';
import {NavLink, Route} from 'react-router-dom'
import Login from "./Login";
import Register from "./Register";
import "../../styles/index.scss"
import css from "./Login.module.scss"
import logo from '../../images/logo.svg'
import googleIcon from '../../images/google.svg'
import facebookIcon from '../../images/facebook.svg'
import line from '../../images/curve-line.svg'
import horizLine from '../../images/horizontal-curve-line.svg'
import {useHistory, withRouter} from "react-router";
import {useTheme} from "../../App";
import {useTranslation} from "react-i18next";
import RecoveryEmail from "../common/modals/Recovery/RecoveryEmail";
import {connect} from "react-redux";
import {setRecoveryToken} from "../../redux/auth/auth-actions";
import ChangePassword from "../common/modals/ChangePassword";
import close from "../../images/close.svg";
import ConfirmEmailError from "../common/modals/ConfirmEmailError/ConfirmEmailError";


const LoginContainer = ({location, recoveryToken, isConfirmError, setRecoveryToken}) => {
  const {t} = useTranslation()
  const {isDark} = useTheme()
  const history = useHistory();
  const [isSuccessRegister, setIsSuccessRegister] = useState(false)
  useEffect(() => {
    if(recoveryToken) history.push('/logbook/auth/reset')
  }, [recoveryToken])

  return (
    <div className={`${css.login} ${isDark && `${css.login__dark}`}`}>
      {(history.location.pathname === '/logbook/auth/recovery' || history.location.pathname === '/logbook/auth/reset') && <div className={'overlay'} />}
      {history.location.pathname === '/logbook/auth/recovery' && <RecoveryEmail isDark={isDark} />}
      {history.location.pathname === '/logbook/auth/reset' && <ChangePassword closeModal={history.goBack} isRecovery={true} token={recoveryToken} isDark={isDark} />}
      {isSuccessRegister && <button className={'tost'}>
        {t('successRegister')}
        <button onClick={() => setIsSuccessRegister(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </button>}
      <div className={css.login__container}>
        <div className={css.login__logoWrapper}>
          <img src={logo}  alt="" className={css.login__logo}/>
          <button className={css.login__signIn}>
            <img src={googleIcon} alt="" className={css.login__icon}/>
            Google
          </button>
          <button className={css.login__signIn}>
            <img src={facebookIcon} alt="" className={css.login__icon}/>
            Facebook
          </button>
        </div>
        <img src={line} alt="" className={css.login__line}/>
        <div className={css.login__content}>
          <div className={css.login__nav}>
            <NavLink to={'/logbook/auth'} className={css.login__link} exact activeClassName={css.login__activeLink}>{t('signIn')}</NavLink>
            <NavLink to={'/logbook/auth/register'} className={css.login__link} activeClassName={css.login__activeLink}>{t('signUp')}</NavLink>
          </div>
          <Route exact path={'/logbook/auth'} render={() => <Login />} />
          <Route exact path={'/logbook/auth/register'} render={() => <Register isSuccessRegister={isSuccessRegister}
                                                                       setIsSuccessRegister={setIsSuccessRegister}/>} />
        </div>
      </div>
      <p className={css.login__politics}>{t('agreePolitics')}
        <NavLink to={'/logbook/polytics'} className={css.login__politicsLink}>{t('privacy')}</NavLink>
      </p>
      <div className={css.login__quest}>
        <img src={horizLine} alt=""/>
        <p className={css.login__questText}>
          {location.pathname === '/logbook/auth' ? <>
            {t('dontHaveAc')}
            <NavLink className={css.login__signLink} to={'/logbook/auth/register'}>{t('getStarted')}</NavLink>
          </> : <>
            {t('isHaveAc')}
            <NavLink className={css.login__signLink} to={'/logbook/auth'}>{t('signIn')}</NavLink>
          </>}
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recoveryToken: state.authReducer.recoveryToken
})

export default connect(mapStateToProps, {setRecoveryToken})(React.memo(withRouter(LoginContainer)))
